import { CustomsOfficeOfTransitDeclared } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { isDeletedWithId } from 'shared/lib/common-util'
import { deleteCustomsOfficeOfTransit } from '../api/deleteCustomsOfficeOfTransit'
import { ErrorResult } from '../../../../shared/models/types'

function useDeleteCustomsOfficeOfTransit() {
  const deleteCustomsOfficesOfTransit = async (
    customsOfficesOfTransit: CustomsOfficeOfTransitDeclared[],
  ): Promise<{ errors: ErrorResult[] }> => {
    const errors: ErrorResult[] = []
    const customsOfficesOfTransitToBeDeleted = customsOfficesOfTransit.filter(isDeletedWithId)
    if (!customsOfficesOfTransitToBeDeleted.length) return { errors }

    const settledDeletePromises = await Promise.allSettled(
      customsOfficesOfTransitToBeDeleted
        .map((customsOffice) => deleteCustomsOfficeOfTransit(customsOffice.id as number)),
    )

    for (let i = 0; i < settledDeletePromises.length; i++) {
      const settledDeletePromise = settledDeletePromises[i]
      if (settledDeletePromise.status === 'rejected') {
        const customsOffice = customsOfficesOfTransitToBeDeleted[i]
        errors.push({
          message: `Customs office of transit with id ${customsOffice.id} delete failed`, // TODO pass down proper axios error?
        })
      }
    }

    return {
      errors,
    }
  }

  return {
    deleteCustomsOfficesOfTransit,
  }
}

export default useDeleteCustomsOfficeOfTransit
